<template>
  <div >
    <ul class="list-group list-group-flush datoscontacto">
      <li class="list-group-item">
        <strong>Ventas: </strong>
       <i class="fab fa-whatsapp"></i>
         316 528 8931</li>
      <li class="list-group-item"><strong>Planta: </strong>  <i class="fab fa-whatsapp"></i> 318 395 3381</li>
      <li class="list-group-item"><strong>Oficina: </strong> <i class="fab fa-whatsapp"></i> 317 553 6343</li>
      <li class="list-group-item"><i class="fa fa-envelope"></i> empaqueslupa@gmail.com</li>
      <li class="list-group-item"><i class="fa fa-map-marker-alt"></i> Cra 1 No. 23-60 San Nicolas Cali - Valle del Cauca</li>
      <li class="list-group-item"> 
        <i class="fa fa-clock"></i> 
        <div>
          <ul style="list-decoration:none">
            <li>Lunes a Viernes</li>
            <li>8:00 am - 12:00 pm</li>
            <li>2:00 pm - 5:00 pm</li>
          </ul>
        </div>
      </li>
      <li class="list-group-item"><i class="fa fa-money-check-alt"></i> 
        <div>
          Medios de Pago:
          <div>
            <img src="../assets/img/bancolombia.png" alt="">
            <img src="../assets/img/daviplata.png" alt="">
            <img src="../assets/img/nequi.png" alt="">
            <img src="../assets/img/avillas.png" alt="">
            <img src="../assets/img/payu.png" alt="">
            
          </div>
        </div>
      </li>
    </ul>
 
  </div>
</template>

<script>

import { mapState } from 'vuex'

  export default {
    data() {
      return {
       
      }
    },
    methods: {
    handleResize() {
     
     }
    },
    beforeCreate(){
        
    },
    computed: {
      ...mapState(['featuredProducts'])
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    background-color: transparent;
  }
 
</style>